import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import AppContent from 'components/AppContent';
import { Colors, Units } from 'Css';

const css = oxygenCss({
  root: {
    backgroundColor: Colors.fullWhite,
    height: '100%',
    paddingTop: Units.keyline,
    boxSizing: 'border-box',
    noHeader: {
      paddingTop: 0
    }
  }
});

class AppPage extends Component {
  static propTypes = {
    noHeader: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    dark: PropTypes.bool,
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    footer: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  static contextTypes = {
    muiTheme: PropTypes.object
  };

  static defaultProps = {
    dark: false,
    header: null,
    footer: null
  };

  render() {
    const { noHeader, className, children, ...other } = this.props;
    const classes = classNames(css.root, className, {
      [css.noHeader]: noHeader
    });
    return (
      <div className={classes} {...other}>
        {this.props.header}
        <AppContent>{children}</AppContent>
        {this.props.footer}
      </div>
    );
  }
}

export default AppPage;



// WEBPACK FOOTER //
// ./src/js/components/AppPage.js